<template>
    <div>
        <ul class="v-upload-list" v-if="showFileList">
            <li v-for="file in fileList" class="v-upload-file">
                <a class="v-upload-filename">
                    <i class="v-icon-document">
                        <img src="//awp-assets.meituan.net/hfe/fep/1a41c4c7bf7f017fe4885c4565e73894/uploadlist.svg"/>
                    </i>{{file.name}}
                </a>
                <span class="v-upload-btn-delete" @click="deleteFile(file)"
                      :class="{'v-upload-disable': disabled === true}">删除</span>
                <v-progress
                        v-if="file.showProgress && showProgress"
                        type="line"
                        :stroke-width="2"
                        :percentage="file.percentage"
                        :status="file.percentage === 100 ? 'success' : ''">
                </v-progress>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        props: {
            fileList: {
                type: Array,
                default () {
                    return []
                }
            },
            disabled: {
                type: Boolean,
                default: false
            },
            showFileList: {
                type: Boolean,
                default: true
            },
            showProgress: {
                type: Boolean,
                default: true
            }

        },
        methods: {
            deleteFile (file) {
                this.$emit('on-delete-file', file)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// upload-list.vue?04b343ee